<template>
    <div v-if="pageLoaded">
        <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header p-2" style="height: 64px;">
                        <h5 class="modal-title">{{$t('Tag Metadata')}}</h5>
                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" v-on:click="closeUploadWindow">
                            <span aria-hidden="true"><cancel-icon class="close-icon" style="height: 30px !important;width: 30px !important;color: #fff;"></cancel-icon></span>
                        </button>
                    </div>
                    <div class="modal-body row p-0">
                        <div class="p-0 h-100"  style="overflow:auto;width:100%;">
                            <ul class="metadata-dock-ul" style="margin-bottom: 0px !important;">
                                <!-- <li v-if="!globalSettingsFromStartup.configure_upload_location_from_screen || isUploadLocationEnabled">
                                    <div class="upload-fields readonlyDiv">
                                        <div class="key-style">
                                            {{$t('Upload path')}}
                                        </div>
                                        <div class="value-style d-inline-flex">
                                            <div class="w-100">
                                                <span style="padding-inline-start:5px;user-select: text !important;cursor:text;">
                                                    {{uploadDetails.upload_path}}
                                                </span>
                                            </div>   
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                    </div>
                                </li> -->
                
                                <li v-if="enableBarcodeFromStartup.enable_department">
                                    <div class="upload-fields">
                                        <div class="key-style">
                                            {{enableBarcodeFromStartup.department_alias &&  enableBarcodeFromStartup.department_alias.alias_name?enableBarcodeFromStartup.department_alias.alias_name:"Department"}}
                                            <span style="color:#858585"> *</span>
                                        </div>
                                        <div class="value-style d-inline-flex" style="padding-inline-start:7px;padding-top:7px">
                                            <departmentsCommonComponent :isDropdown="true" @updateSelectedDepartments="updateSelectedDepartments">
                                            </departmentsCommonComponent>
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                    </div>
                                </li>
                                
                                <li v-if="enableBarcodeFromStartup.enable_reference_id_workflow">
                                    <div class="upload-fields">
                                        <div class="key-style">
                                            {{enableBarcodeFromStartup.alias &&  enableBarcodeFromStartup.alias.alias_name?enableBarcodeFromStartup.alias.alias_name:"Reference ID"}}
                                            <span style="color:#858585"> *</span>
                                        </div>
                                        <div class="value-style d-inline-flex">
                                            <div class="w-100">
                                                <input
                                                    v-model="barcodeName"
                                                    type="text"
                                                    class="rounded input-fields text-light w-100"
                                                    style="margin-inline-start:5px;padding: 4px;"
                                                    ref="slug_name_field_in_seq_metadata"
                                                    :placeholder="enableBarcodeFromStartup.alias &&  enableBarcodeFromStartup.alias.alias_name?'Enter '+enableBarcodeFromStartup.alias.alias_name:'Enter Reference ID'"
                                                />
                                            </div>   
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                    </div>
                                </li>
                            </ul>
                            <sequence-metadata style="width:100%" :fixMinWidth="false" :screenType="selectedScreenType()" :enableMediaSlug="false" :enableOnlyFields="false" ref="sequenceMetadataModel" :defaultCategory="defaultAssetCatalog" :parentRouteName="parentRouteInfo.name" :assetsBrowseAccess="['full-control','read-write']"></sequence-metadata>
                        </div>
                    </div>
                    <div class="modal-footer p-0 primary-btn-style">
                        <div class="w-50" style="padding-inline-start:2%;padding-top:1%">
                            <button class="btn btn-outline-primary p-0 mr-2" v-on:click="modifyAssetsMetdata()">Save</button>
                            <button class="btn btn-outline-secondary mr-2" data-dismiss="modal" v-on:click="closeUploadWindow">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from "vuex";
    import Constants from "../../components.constants.js";
    import {NotifierConstants} from "../../components.constants.js";
    import Utils from "../../components.utils";
    import SequenceMetadata from "../files/SequenceMetadata.vue";
    import "vue2-datepicker/index.css";
    import cancelIcon from "../core/InlineCancelField.vue"
    import departmentsCommonComponent from "../miscellaneous/departmentsCommonComponent.vue";
    
    export default {
        data(){
            return {
                pageLoaded:false,
                uploadDetails:{},
                parentRouteInfo:{},
                file: "",
                fileInfo:"",
                filesList:["test.mp6"],
                barcodeName:'',
                selectedDepartments:null,
                defaultAssetCatalog:null,
            };
        },
        computed:{
            ...mapGetters("upload",["getAllJobs"]),
            ...mapGetters("users", ["getLoggedInUserPrivilege","getLoggedInUserId"]),
            ...mapGetters("categories", ["getRootCategoryDetails"]),
            
            enableBarcodeFromStartup:{
                get(){
                    return this.$store.state.startUpData.startUpDataDetails;
                }
            },
            globalSettingsFromStartup:{
                get(){
                    return this.$store.state.startUpData.startUpDataDetails;
                }
            },
            isUploadLocationEnabled(){
                return (this.globalSettingsFromStartup.configure_upload_location_from_screen &&
                        this.globalSettingsFromStartup.screens.findIndex(op=>(op.name=='Upload' &&
                        op.field_id_list.includes('Upload path'))) >= 0);
            }
        },
        components:{
            "sequence-metadata":SequenceMetadata,
            'cancel-icon':cancelIcon,
            departmentsCommonComponent
        },
        methods: {
            ...mapMutations("websocket",["addWSEventListener","removeWSEventListener"]),
            ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
            ...mapActions("assets",["updateAssetMetadata","getAllAssetsFromServer"]),
            ...mapActions("startUpData",["getStartUpDataFromServer"]),
            ...mapActions("users",["logOutFromServer"]),
            ...mapActions("websocket",["connectToWebSocket"]),
            closeUploadWindow(){
                this.filesList = [];
                this.$emit('close');
            },
            selectedScreenType(){
                return "Upload";
            },
            updateSelectedDepartments(value){
                this.selectedDepartments = value;
            },
            modifyAssetsMetdata(){
                let payload = {};
                if(!this.filesList || this.filesList.length <= 0){
                    alert("Invalid storage path provided.");
                    return;
                }
                let SeqMetadata = this.$refs.sequenceMetadataModel.getSequenceMetadataMap(false);
                if(!SeqMetadata){
                    console.log("Metadata: Mandatory fields were missed. Hence returning.")
                    return false;
                }
                if(SeqMetadata.parent_id_path.length == 0){
                    alert("Please select catalog");
                    return false;
                }
        
                payload = SeqMetadata;
                let pathList = this.filesList.map((path) => {
                                    // Split the path to separate the parent path and file name
                                    const lastSlashIndex = path.lastIndexOf('/');
                                    const parentPath = path.substring(0, lastSlashIndex);
                                    const fileName = path.substring(lastSlashIndex + 1);

                                    // Construct the object
                                    return {
                                        file_name: fileName,
                                        parent_path: parentPath,
                                        state: 'GROWING',
                                        file_type: 'file',
                                        from_action: 'VTR Ingest'
                                    };
                                });
                payload["attached_file"] = pathList
                if('parent_id_path' in payload){
                    if('metadata' in payload){
                        payload['metadata']['parent_id_path'] = payload['parent_id_path'];
                        delete payload['parent_id_path']
                    }
                }
                if(this.barcodeName.length > 0){
                    payload['reference_id'] = this.barcodeName;
                    if(this.enableBarcodeFromStartup.enable_reference_id_workflow && this.barcodeName.trim().length == 0){
                        alert("Please add barcode");
                        return false;
                    }
                }
        
                if(this.enableBarcodeFromStartup.enable_department && this.selectedDepartments){
                    payload['department_id'] = this.selectedDepartments._id;
                }else if(this.enableBarcodeFromStartup.enable_department){
                    alert(this.enableBarcodeFromStartup.department_alias &&  this.enableBarcodeFromStartup.department_alias.alias_name?'Please select '+this.enableBarcodeFromStartup.department_alias.alias_name:"Please select Department");
                    return false;
                }
                this.updateAssetMetadata(payload).then((data)=>{
                    if (Utils.isAcceptedStatusCode(data.statusCode)) {
                        let file_uids = [];
                        if('file' in data){
                            if(Array.isArray(data['file'])){
                                file_uids = data["file"].map(file => file.file_uid);
                            }else{
                                file_uids = data['file']['file_uid']
                            }
                        }
                        window.parent.postMessage({
                            cmd: 'metadataUpdated',
                            params: {
                                ['file_uid']:file_uids
                            }
                        },"*");
                        this.closeUploadWindow();
                        this.filesList = [];
                    } else {
                        this.$toast.error(data.message);
                    }
                });
            },
            receiveMessage(event) {
                if (!event.origin.includes("/fusion-browse/NRAA/uploadMetadata")) {
                    return; // Ignore messages from unknown origins
                }
                const { type, data } = event.data;
                if (type === 'storagePath') {
                    if(Array.isArray(data)){
                        this.filesList = data;
                    }else{
                        this.filesList = [data];
                    }
                    console.log(this.filesList); // ['share://INGEST/VTR_INGEST/Demo.mxf']
                }
            },
            updateGlobalSettingsValueFromNotification(notification){
                notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification;
                if(Object.keys(notification.message).includes('enable_reference_id_workflow')){
                    if(Object.keys(this.getStartUpDataFromInCache()).includes('enable_reference_id_workflow')){
                        this.$set(this.getStartUpDataFromInCache(),"enable_reference_id_workflow",notification.message.enable_reference_id_workflow);
                    }
                }
            },
            handleUserLogin(notification){
                notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
                if(notification.message){
                    let session_info = notification.message
                    if(notification.message_type == NotifierConstants.licenseUpdatedNotification){
                        alert('License got updated.\nPlease log in again.');
                        this.logOutFromServer()
                    }else{
                        if ((session_info.logged_in)&&(session_info.user_id == this.getLoggedInUserId)){
                            let session_id = Utils.getCookieValue("session_id")
                            if(session_info && Object.prototype.hasOwnProperty.call(session_info,'logged_in_from_mobile') && 
                                session_info.logged_in_from_mobile)  return; // don't logout as mobile is having different session
                            if ((session_id != session_info.session_id)&&(this.getClientSystemIP!=session_info.system_ip)){
                                alert(`User logged in to different system(${session_info.system_ip}), So logging out here`)
                                this.logOutFromServer();
                            }
                        }
                    }
                }
            },
            // registerWebsocketNotifier(){
            //     this.removeWSEventListener({eventname:NotifierConstants.globalSettingsUpdatedNotification, callback:this.updateGlobalSettingsValueFromNotification, parent:"uploadMetadata"}); 
            //     this.addWSEventListener({eventname:[NotifierConstants.userLoggedInNotification,NotifierConstants.licenseUpdatedNotification], callback:this.handleUserLogin,parent:"uploadMetadata"})
            // }
        },
        async created(){
            let startupRes = await this.getStartUpDataFromServer();
            if(Constants.acceptedStatusCodes.includes(startupRes.statusCode)){
                if(startupRes["upload_settings"] && startupRes["upload_settings"].length > 0){
                    this.uploadDetails = startupRes["upload_settings"][0];
                    if(this.uploadDetails && "catalog_info" in this.uploadDetails){
                        this.defaultAssetCatalog = this.uploadDetails["catalog_info"];
                    }
                }else{
                    let payload = {params:{catalog_id: Constants.rootCategory,asset_type:"catalog"}}
                    let data = await this.getAllAssetsFromServer(payload);
                    if (Constants.acceptedStatusCodes.includes(data.statusCode)){
                        let rootElement = data.assets[0];
                        this.defaultAssetCatalog = {
                            _id:rootElement._id,
                            catalog_name:rootElement.catalog_name,
                            parent_id_path:[rootElement.parent_id_path[0]],
                            parent_path:[{"_id":rootElement.parent_id_path[0], "value":rootElement.parent_path[0].value}]
                        }
                    }
                }
            }
            Utils.updateCookieByKeyName("context","assets-metadata");
            window.addEventListener('message', this.receiveMessage);
            if(!this.filesList || this.filesList.length <= 0){
                alert("Invalid storage path provided.");
                this.pageLoaded = false;
            }else{
                this.pageLoaded = true;
            }
        },
        beforeDestroy(){
            window.removeEventListener('message', this.receiveMessage);
        }
    };
</script>
    
<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $highlight-font-color:#ff9800;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555; 
    $input-field-padding:.375rem 10px;
    $filter-border-color: #5a5a5a;
    $filter-bg-color: #2a2a2a;
    .modal-dialog {
        width: 100vw;
        max-width: 100%;
        height:100vh;
        margin: 0;
        padding: 0;
    }
    
    .view-tags{
        font-size: 12px;
        height: 24px;
        display: inline-flex;
        margin:2px !important;
        border: $border-color !important;
        border-radius: 15px !important;
        min-width: 50px;
        padding: 0px !important;
        text-align: center;
        width:auto !important;
        div{
            padding: 0px 8px;
            margin-inline-start: 0px;
            font-size: 12px;
            border-radius: 15px !important;
            position: relative;
            top: 1px;
        }
    }
      
    .modal-content {
        height: auto;
        min-height: 100%;
        border: 0 none;
        border-radius: 0;
        box-shadow: none;
        background: $primary-background !important;
        border: $border-color;
        .modal-body{
            background: $primary-background;
            overflow:auto;
            height:300px;
            padding: 0px 0px 0px 0px;
            display:inline-flex;
            width:100%;
        }
    }
    
    .modal {
        text-align: center;
        padding: 0!important;
        display:block;
    }
    .modal:before {
        content: '';
        display: inline-block;
        height: 100%;
        vertical-align: middle;
        margin-inline-end: -4px;
    }
    .modal-dialog {
        display: inline-block;
        text-align: start;
        vertical-align: middle;
    }
    
    .btn{
        font-size:14px !important;
        height:100%;
    }
    
    /* width */
    ::-webkit-scrollbar {
        width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $scrollbar-track-background;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $scrollbar-thumb-background;
    }
    
    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $scrollbar-thumb-on-hover-background;
    }
    
    .border{
        border: $border-color !important;
    }
    
    .activeclass{
        color: $active-blue;
        .file-size-display{
            color:$active-blue;
        }
    }
    
    .activeFile{
        color:#64a8f0;
    }
    
    .modal-header,.modal-footer{
        border: none !important;
        background: $secondary-background-color;
        align-items: unset;
        .modal-title{
            color:$text-color;
            padding:3px;
        }
    }
    
    ul{
        list-style-type: none;
    }
    .modal-header .close {
        // margin: -1rem -13px -1rem auto !important;
        margin:0px !important;
        padding: 0px !important;
    }
    
    .primary-btn-style{
        margin-top:1%;
        height:65px;
        display:inline-flex !important;
        flex-wrap: nowrap !important;
        button{
            height: 37px !important;
            border-radius: 5px;
            width: 70px;
            font-size:14px;
            float:inline-end;
        }
    }
    
    .search-bar-comm-style{
        height:30px;
        position:relative;
        input{
            border:$border-color;
            height: 25px;
            padding-inline-start: 3%;
        }
        svg{
            position: absolute;
            inset-inline-start:21px;
            top: 21%;
        }
    }
    
    .secondary-btn-style{
        color:$text-color;
        font-size:12px;
    }
    
    .modal-footer{
        justify-content: end;
        align-items: center;
    }
    
    
    input[type="radio"] {
        outline: none !important;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        display: inline-block;
        padding: 4px;
        border-radius: 50% !important;
        width: 20px;
        border: $border-color !important;
        background-color:$primary-background !important;
        height: 20px;
    }
    .row{
        margin:-12px !important;
        margin-inline-start:0px !important;
    }
    /* appearance for checked radiobutton */
    input[type="radio"]:checked {
        background-color: $active-blue !important;
        background: radial-gradient(circle, $active-blue 40%, $primary-background 49%, $primary-background 100%) !important;
        border: $border-color !important;
    }
    
    .view-tags{
        font-size: 12px;
        height: 24px;
        display: inline-flex;
        margin:2px !important;
        border: $border-color !important;
        border-radius: 15px !important;
        min-width: 50px;
        padding: 0px !important;
        text-align: center;
        width:auto !important;
        span{
            padding: 0px 8px;
            margin-inline-start: 0px;
            font-size: 12px;
            border-radius: 15px !important;
            position: relative;
            top: 1px;
        }
    }
    
    .view-tags:hover{
        border: $border-color !important;
    }
    
    .activeTag{
        color: $active-blue !important;
    }
    
    .metadata-dock-ul{
        list-style-type: none;
        padding: 0px 3px;
        display:grid;
        background:$primary-background;
        li{
            display:inline-flex;
            padding:4px;
            border-radius: 4px;
            width:100% !important;
            .key-style{
                color:$dull-text-color;
                width:30%;
                text-align: start;
                font-size:14px;
                padding-inline-start: 5px;
                padding-inline-end: 5px;
                margin-top:3px;
            }
            .value-style{
                color: $text-color;
                width: 99%;
                text-align: start;
                padding-top: 3px;
                padding-bottom: 3px;
                padding-inline-end: 5px;
                .slug-ellipsis{
                    white-space: nowrap;
                    max-width: 350px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }
    }
    .input-fields{
        border: $border-color !important;
        border-radius: 5px !important;
        margin-inline-start:5px;
        margin-bottom: 7px;
        height:40px;
    }
    
    .input-fields:focus{
        outline: unset;
    }
    
    .upload-fields {
        display: inline-block;
        padding: 7px;
        border-radius: 4px;
        margin: 4px 0px;
        width: 100%;
        position: relative;
        border: 1px solid #2b2b2b !important;
    }
    
    .progress{
        width:85%;
        border: 1px solid #2d2d2d;
        background: #222222;
    }
    
    .progress-percentage{
        position: relative;
        bottom: 2px;
        inset-inline-start:3px;
    }
    
    .progress-speed{
        position: relative;
        inset-inline-start:2%;
        bottom: 2px;
        color: #666;
        width:100px;
    }
    
    .tags-display-ul .show-tags-delete{
        visibility:hidden;
    }
    
    .tags-display-ul li:hover .show-tags-delete{
        visibility: visible;
    }
    
    .show-tags-delete{
        position: relative;
        top: 2px;
    }
    
    .secondary-btn-style:hover{
        text-decoration: underline;
    }
    
    .close-icon:hover{
        background: #373737;
        border-radius: 20px;
    }
    .readonlyDiv{
        background: transparent !important;
        border: none !important;
        padding-inline-start:4px;
    }
    .selected-thumbnail-display{
        height: 330px;
        width: 100%;
        display: inline-block;
        border: 1px solid #2B2B2B;
        display: flex;
        justify-content: center;
        align-items: center;
        position:relative;
        div{
            flex: 0 0 120px;
        }
        img{
            height:100%;
        }
        svg{
            float: inline-end;
            margin-top:5px;
        }
    }
    
    .bigger-checkboxes {
        height: 30px;
        width: 20px;
        position: absolute;
        inset-inline-start:3px;
        top: 4px;
    }
    
    .set-thumbnail-btn{
        position:absolute;
        bottom: -25px;
        inset-inline-start:17%;
    }
    .set-thumbnail-btn:hover{
        text-decoration: underline;
    }
    
    .upload-status-text{
        text-align: start;
        float:inline-start;
        font-size:11px;
    }
    
    .remove-selected-file{
        visibility:hidden;
    }
    
    .file-name-with-progress-bar-wrapper:hover{
        color:$active-blue;
        .remove-selected-file{
            visibility: visible;
            position: relative;
            bottom: 2px;
        }
        .file-size-display{
            color:$active-blue;
        }
    } 
    
    .upload-files-count{
        position: sticky;
        top: -1px;
        background: $primary-background;
        z-index:9;
    }
    
    .file-size-display{
        color: #a2a0a0;
        font-size: 11px;
        width: 55px;
        font-weight: 900;
        position: relative;
        top: 1px;
    }
</style>    